export default {
  Welcome: 'Welcome',
  Customization: {
    CustomizeDashboard: 'Customize dashboard',
    EditMode: 'You are currently in edit mode',
    AddWidget: 'Add widget',
    Reset: 'Reset',
    SelectWidget: 'Select a widget to add',
    Settings: 'Settings',
  },
};
